"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_KEY = exports.API_ACTIONS = void 0;
/* eslint-disable max-lines */
const chat_1 = require("./chat");
const google_1 = require("./google");
const DEFAULT_TIMEOUT = 300000;
const API_KEY = Object.assign(Object.assign({}, google_1.GOOGLE_API_KEY), chat_1.ZENDESK_API_KEY);
exports.API_KEY = API_KEY;
const API_ACTIONS = {
    ADDRESS_FORM_FIELD_OPTIONS: {
        method: 'GET',
        responseContentType: 'application/json',
        url: '/_ui/responsive/common/json/Country_en.json',
    },
    CONTACT_FORM_SUBMIT: {
        method: 'POST',
        requestContentType: 'multipart/form-data',
        timeout: 1200000000,
        url: '/api/v1/contactus/createTicket',
    },
    EVENT_RSVP: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/event/rsvp',
    },
    CART_ADD_PAYMENT: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/payment/add',
    },
    CART_ADD_ENTRY: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/entries/add',
    },
    CART_GIFT_CARD_BALANCE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/giftCardBalance',
    },
    CART_RESET_PAYMENT: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/payment/reset',
    },
    CART_UPDATE_BILLING: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/billing/update',
    },
    CART_UPDATE_CUSTOMER: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/customer/update',
    },
    CART_UPDATE_SHIPPING: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/shipping/update',
    },
    CART_FETCH: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/aesopCart',
    },
    CHECKOUT_EMAIL_AVAILABILITY: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/email/availability',
    },
    CART_UPDATE_SAMPLES: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/cart/sample/update',
    },
    CART_ADD_PROMO_CODE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/aesopCart/promo/apply',
    },
    CART_REMOVE_PROMO_CODE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/aesopCart/promo/remove',
    },
    CART_UPDATE_ENTRY: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/aesopCart/update',
    },
    USER_SESSION: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/aesopCart/getUserSession',
    },
    CART: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/aesopCart/pageLoad/checkout',
    },
    CART_CHECKOUT: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/checkout/placeorder',
    },
    CATEGORY: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/category/:category/:subcategory',
    },
    DISABLE_SAVED_CARD: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/payment/disable',
    },
    NAV_SHOP: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/nav/shop',
    },
    SAMPLE_REQUEST: {
        method: 'POST',
        url: '/api/v1/sampleRequest',
    },
    NEWSLETTER_SUBSCRIBE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/newsletter/subscribe',
    },
    SEARCH: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/search',
    },
    SEARCH_SUGGESTIONS: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/search/suggestions',
    },
    SKIN_TYPES_LANDING_PAGE: {
        method: 'GET',
        url: '/api/v1/skinTypes',
    },
    NAV_READ: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/nav/read',
    },
    STORE_LOCATIONS: {
        method: 'GET',
        url: '/api/v1/storeLocations',
    },
    USER_ADDRESS_UPDATE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/accountApi/createUpdateAddress',
    },
    USER_DETAILS_UPDATE: {
        method: 'POST',
        url: '/api/v1/accountApi/updateProfile',
        timeout: DEFAULT_TIMEOUT,
    },
    USER_FORGOT_PASSWORD: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/accountApi/forgotPassword',
    },
    USER_LOAD: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/myAccount',
    },
    USER_LOGIN: {
        method: 'POST',
        requestContentType: 'application/x-www-form-urlencoded',
        timeout: 150000,
        url: '/api/v1/j_spring_security_check',
    },
    USER_LOGOUT: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/logout',
    },
    USER_NEWSLETTERS_LOAD: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/newsletterApi/newsletters',
    },
    USER_NEWSLETTERS_UPDATE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/newsletterApi/newslettersUpdate',
    },
    USER_ORDERS_LOAD: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/accountApi/orders',
    },
    USER_PASSWORD_UPDATE: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/accountApi/updatePassword',
    },
    USER_REGISTER: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/login/register',
    },
    USER_RESET_PASSWORD: {
        method: 'POST',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/user/resetPassword',
    },
    FABULIST_LOAD_MORE: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/r/the-fabulist/page/:page',
    },
    USER_ORDERS_SUMMARY_LOAD: {
        method: 'GET',
        timeout: DEFAULT_TIMEOUT,
        url: '/api/v1/accountApi/orders/summary',
    },
    CART_CHECKOUT_ADYEN_PAYPAL: {
        apiCSRFToken: '',
        method: 'POST',
        url: '/checkout/placeorder',
    },
    CART_REORDER: {
        method: 'GET',
        responseContentType: 'application/json',
        url: '/checkout/reorder/:orderCode',
    },
    CART_CHECKOUT_ADYEN: {
        method: 'POST',
        url: '/checkout/placeorder',
    },
    BIS_USER_NOTIFICATION: {
        apiCSRFToken: '',
        method: 'POST',
        url: '/api/product/stocknotifications',
    },
    PRODUCTS: {
        method: 'GET',
        responseContentType: 'application/json',
        url: '/api/v1/products',
    },
};
exports.API_ACTIONS = API_ACTIONS;
//# sourceMappingURL=api.js.map